const API_BASE = '/api';

export async function submitAssessment(data) {
  const response = await fetch(`${API_BASE}/assessment`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Submission failed' }));
    throw new Error(error.message || 'Submission failed');
  }

  return response.json();
}

export async function sendReportEmail(assessmentId) {
  const response = await fetch(`${API_BASE}/assessment/${assessmentId}/send-email`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Email send failed' }));
    throw new Error(error.message || 'Email send failed');
  }

  return response.json();
}

export function getPdfUrl(assessmentId) {
  return `${API_BASE}/assessment/${assessmentId}/pdf`;
}

export async function getAssessment(assessmentId) {
  const response = await fetch(`${API_BASE}/assessment/${assessmentId}`);

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Not found' }));
    throw new Error(error.message || 'Not found');
  }

  return response.json();
}
